import { lazy, Suspense } from 'react';
import { Route, Routes, useParams } from 'react-router-dom';
import { Speaker } from './routes/Speaker';
import { GuestRoom } from './routes/GuestRoom';
import { classifyHandle } from './lib/route-roles';

// Der Admin-Zweig liegt hinter Zero Trust und darf NICHT im oeffentlichen
// Bundle landen: /:handle bedient Sprecher UND Gaeste ohne Login, und ein
// gemeinsames Bundle liefert den Admin-Code an jeden von ihnen mit aus — im
// Inspector lesbar. Kein Datenleck (Secrets serverseitig, /api/admin/* hinter
// ZT + JWT-Gate), aber Komponenten-, Routen- und API-Pfadnamen sind
// Aufklaerungsmaterial.
// Siehe 00_TRO_DEV_DOCS/public-frontend-check.md (Check B).
const SessionBackend = lazy(() =>
  import('./routes/SessionBackend').then((m) => ({ default: m.SessionBackend }))
);
const Admin = lazy(() => import('./routes/Admin').then((m) => ({ default: m.Admin })));

// Root-Segment: Sprecher (studio-<slug>) oder Gäste-Token. Reserviert sind /, /admin, /admin/studio/:slug.
function HandleResolver() {
  const { handle = '' } = useParams();
  const role = classifyHandle(handle);
  return role.kind === 'speaker' ? <Speaker slug={role.slug} /> : <GuestRoom token={role.token} />;
}

export default function App() {
  return (
    // Nur die beiden Admin-Routen sind lazy — der Fallback erscheint also
    // ausschliesslich dort. Sprecher- und Gaeste-Pfad bleiben statisch, damit
    // eine laufende Session nie auf einen Chunk warten muss.
    <Suspense fallback={<AdminLoading />}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/admin" element={<SessionBackend />} />
        <Route path="/admin/studio/:slug" element={<Admin />} />
        <Route path="/:handle" element={<HandleResolver />} />
      </Routes>
    </Suspense>
  );
}

function AdminLoading() {
  return <main style={{ padding: 24 }}>Lädt …</main>;
}

// Nackte Brand-Domain: bewusst NUR der Tool-Name. Die frühere Linkliste nannte
// den Admin-Pfad und das komplette URL-Schema für Sprecher- und Gäste-Links
// (`/studio-<slug>`, `/<token>`) — auf einer Seite, die ohne Login erreichbar
// ist. Wer hier landet, hat nichts verloren; wer einen Link hat, kennt ihn.
function Home() {
  return (
    <main style={{ padding: 24 }}>
      <h1>TRO Sessions</h1>
    </main>
  );
}
